/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import { CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router';
import { getParams } from 'helpers';

export function NewInvoicesPaid() {
    
    const [paymentStatus, setPaymentStatus] = useState<string|null>(null);
    const history = useHistory();

    useEffect(() => {
        const params = getParams(window.location.search);
        if (params.payment) {
            setPaymentStatus(params.payment);
            history.replace('/esileht');
            if (params.payment === 'success') {
                setTimeout(() => clearPaymentStatus(), 5000);
            }
        }   
    }, []);

    const clearPaymentStatus = () => {
        setPaymentStatus(null);
    }
    return (
        <>
        {
            <CSSTransition in={!!paymentStatus} timeout={250} unmountOnExit classNames="alert">
                {paymentStatus === 'success' || !paymentStatus
                ? <div className="alert alert-success"><i className="alert-icon icon__check"></i>Makse oli edukas!</div>
                : <div className="alert alert-danger"><i className='alert-icon icon__close--masked mr-2'></i>Makse ebaõnnestus!</div>
                }
             </CSSTransition>
        }
        </>
    )
}